import { bybitRestService } from '@/services/bybit'
import { ApiError } from '../tigerx/tegerx.api'
import { bybitHistoryToHistoryItem } from './bybit.mappers'

export const BybitApi = {
  getHistoryTradeData: async (filters: any) => {
    try {
      const { page, ...rest } = filters
      const [historyRes] = await Promise.all([
        bybitRestService.getHistoriesTrade(rest).catch(err => {
          throw { source: 'hstoryRes', status: err.response?.status || 500, message: err.message }
        }),
      ])

      const list = historyRes?.data?.result?.list ?? []
      const nextCursor = historyRes?.data?.result?.nextPageCursor ?? null
      const limit = rest.limit ?? 20

      return {
        historyFormatted: list.map(bybitHistoryToHistoryItem),
        page: filters.page ?? 1,
        nextCursor,
        reachedEnd: list.length < limit || !nextCursor,
      }
    } catch (error: unknown) {
      const apiError = error as ApiError
      console.error('Error transfer data:', apiError)

      return {
        error: {
          source: apiError.source,
          status: apiError.status,
          message: apiError.message,
        },
      }
    }
  },
}
